import { Icons } from '@/assets/icons/icons';
import { Button } from '@/components/ui/Button';
import { DropdownMenu } from '@/components/ui/dropdown-menu';
import {
  ECHONOTES_SECTION_DEFS,
  type EchoNotesSection,
} from '@/features/echonotes/echonotes-query';

interface EchoNotesSectionSelectorProps {
  selectedSection: EchoNotesSection;
  onSectionChange: (section: EchoNotesSection) => void;
}

export function EchoNotesSectionSelector({
  selectedSection,
  onSectionChange,
}: EchoNotesSectionSelectorProps) {
  const selectedLabel =
    ECHONOTES_SECTION_DEFS.find((d) => d.section === selectedSection)?.label ??
    selectedSection;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          {selectedLabel}
          <Icons.chevronDown className="h-3 w-3" />
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        {ECHONOTES_SECTION_DEFS.map((def) => (
          <DropdownMenu.Item
            key={def.section}
            onClick={() => onSectionChange(def.section)}
          >
            {def.label}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
